import { useEffect } from 'react';
import { tourRoleFor } from '@/components/tour/tours';
import { useTour } from '@/components/tour/useTour';
import { tourService } from '@/services/tourService';
import { useAuthStore } from '@/stores/useAuthStore';

/**
 * Starts the role tour once, after the shell has painted.
 * Login, reset and verify routes never mount the dashboard, so they stay quiet.
 */
export function useTourAutoStart(): void {
  const userId = useAuthStore((state) => state.user?.id ?? null);
  const ruolo = useAuthStore((state) => state.user?.ruolo ?? null);
  const staffSeen = useAuthStore((state) => state.user?.tour_staff_completato_at ?? null);
  const clienteSeen = useAuthStore((state) => state.user?.tour_cliente_completato_at ?? null);
  const { startTour } = useTour();

  useEffect(() => {
    if (!userId || !ruolo) return;
    const tipo = tourRoleFor(ruolo);
    if (tourService.hasSeen(tipo)) return;
    const backendSeen = tipo === 'staff' ? staffSeen : clienteSeen;
    if (backendSeen) {
      tourService.remember(tipo);
      return;
    }
    const timer = window.setTimeout(() => {
      if (tourService.wasStarted()) return;
      startTour(tipo);
    }, 800);
    return () => window.clearTimeout(timer);
  }, [userId, ruolo, staffSeen, clienteSeen, startTour]);
}
